import { useFormContext, useWatch } from "react-hook-form";

import { colors } from "#app/theme/v1/colors";
import { QuoteRequestLineFormData } from "#modules/quoteRequestLines/types/QuoteRequestLineFormData";
import { useQuoteRequestLine } from "#modules/quoteRequestLines/view/useQuoteRequestLine";
import { ConceptionCost } from "#modules/quoteRequestLines/views/DetailsPanel/Conception/ConceptionCost";
import { CostCollapsable } from "#modules/quoteRequestLines/views/DetailsPanel/CostCollapsable";
import { computeGeneralPrice } from "shared";

export const ConceptionSection = () => {
  const { control } = useFormContext<QuoteRequestLineFormData>();
  const quoteRequestLineId = useWatch({ control, name: "quoteRequestLineId" });

  const { quoteRequestLine } = useQuoteRequestLine({ id: quoteRequestLineId });

  if (!quoteRequestLine) {
    return null;
  }
  const { partGeneralCost } = computeGeneralPrice(quoteRequestLine);

  if (
    !quoteRequestLine.designOfficeTime ||
    !quoteRequestLine.designOfficeHourlyRate ||
    !quoteRequestLine.designOfficeMarginRatio ||
    !partGeneralCost
  ) {
    return null;
  }

  return (
    <CostCollapsable title="Coût conception" color={colors.violet[5]} value={partGeneralCost}>
      <ConceptionCost
        designOfficeHourlyRate={quoteRequestLine.designOfficeHourlyRate}
        designOfficeTime={quoteRequestLine.designOfficeTime}
      />
    </CostCollapsable>
  );
};
